import type { RunningPrompt } from "@storytell/client";
import type { StreamingChatId } from "@storytell/streaming";

export interface RunningChatEntry {
  chatId: StreamingChatId;
  // Server-snapshot entries carry these; entries known only from this tab's
  // stream leave them unset and the label/navigation fallbacks apply.
  title?: string;
  projectId?: string;
  preview?: string;
}

// Union of this tab's live streaming state and the server-side registry
// snapshot, deduped by chat. The local source proves a chat is generating right
// now; the server source survives page loads and carries title/project. A chat
// in both keeps the server metadata.
export function mergeRunningSources(local: StreamingChatId[], server: RunningPrompt[]): RunningChatEntry[] {
  const out: RunningChatEntry[] = [];
  const seen = new Set<string>();

  for (const entry of server) {
    if (seen.has(entry.chatId)) continue;
    seen.add(entry.chatId);
    out.push({
      chatId: entry.chatId as StreamingChatId,
      title: entry.title === "" ? undefined : entry.title,
      projectId: entry.projectId === "" ? undefined : entry.projectId,
      preview: entry.preview === "" ? undefined : entry.preview,
    });
  }

  for (const chatId of local) {
    if (seen.has(chatId)) continue;
    seen.add(chatId);
    out.push({ chatId });
  }

  return out;
}
